import React from 'react';
import styles from '../styles/historyButton.module.css';

interface HistoryButtonProps {
  stepNumber?: number;
  stepTitle?: string;
  stepData?: any;
  /** @deprecated Date display is always on; ignored */
  isOptedOut?: boolean;
  onStepUpdated?: () => void;
}

const HistoryButton: React.FC<HistoryButtonProps> = ({ onStepUpdated }) => {
  const handleClick = () => {
    if (onStepUpdated) {
      onStepUpdated();
    }
  };

  return (
    <button 
      className={styles.historyButton}
      onClick={handleClick}
      title="View timeline"
      tabIndex={-1}
    >
      📅
    </button>
  );
};

export default HistoryButton;
